import { useTranslation } from 'react-i18next'

const Classmate2Start = (props) => {
  const { t } = useTranslation()
  
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="classmate2-before-title"
      fill="none"
      {...props}
    >
      <title id="classmate2-before-title">{t('antagonists:classmate2:components:start')}</title>
      <defs>
        <clipPath id="classmate2-b">
          <path
            d="M1597.2 952.93c-8.32.32-17.21 10.49-18.71 10.83-4.08.92-.54-6.83-1.71-7.07-1.17-.24-3.39 8.43-4.41 16.08-1.02 7.65-1.53 11.05-.17 12.07 1.36 1.02 13.59 6.63 14.95 10.71 1.36 4.08 4.42 15.12 17.5 16.31 13.08 1.19 23.79-.51 24.47-4.59.68-4.08 1.53-11.9-1.53-15.8-3.06-3.91-9.69-7.65-13.42-14.78-3.74-7.14-7.63-15.9-8.9-18.36-1.38-2.67-3.66-5.55-8.08-5.38Z"
            style={{
              fill: '#497125',
            }}
          />
        </clipPath>
        <clipPath id="classmate2-c">
          <path
            d="M1511.7 954.91c1.28-.33 3.11 11.65 4.08 15.97 1.8 8.05.34 15.46-.17 16.99-.51 1.53-18.52 2.21-28.89 7.65-10.37 5.44-20.56 7.99-32.46 7.99-11.9 0-20.39-4.59-21.24-7.14s-2.89-10.03 1.19-12.24c4.08-2.21 18.18-6.8 24.13-10.37 5.95-3.57 23.39-24.9 32.73-19.97 9.35 4.93 10.43 16.74 15.87 14.19 5.44-2.55 3.47-12.75 4.76-13.08Z"
            style={{
              fill: '#497125',
            }}
          />
        </clipPath>
        <clipPath id="classmate2-d">
          <path
            d="M1516.52 374.87c-29.46 6.17-31.89 28.37-30.77 46.83 1.13 18.46 10.12 28.96 14.25 41.87 4.13 12.91 3.57 46.11 3.57 46.11l9.65-.32s5.61-20.65 5.02-29.82c-.78-12.27-6.84-30.03-6.84-30.03l45.15-15.76s2.36 17.19 7.81 29.39c5.45 12.2 12.19 22.58 12.19 22.58l14.06-3.8s-.7-4.71-7.44-16.66c-5.2-9.23-10.28-20.07-14.15-36.72-1.49-6.44-3.57-29.43-12.4-41.59-7.82-10.76-21.17-16.04-40.11-12.07Z"
            style={{
              fill: '#394a35',
            }}
          />
        </clipPath>
        <clipPath id="classmate2-e">
          <path
            d="M1638.59 661.01s5.4-6.2 6.7-18c1.29-11.8-6.9-35.68-15.99-65.5s-15.34-78.85-30.2-87.64c-5.94-3.51-12.19-1.5-17.37-1.6-11.4-.23-16.6-1.29-16.6-1.29s-6.85 6.19-29.93 7.13c-22.36.91-30.87-5.14-30.87-5.14s-12.86 4.95-20.42 7.3c-7.35 2.29-13.87 4.31-19.5 14.67-6.27 11.53-12.41 64.25-12.41 64.25l-14.61-16.37-10.09-12.63-16.77 13.83 5.82 11.15s-4.96 11.04 1.67 23.95c5.64 10.99 37.87 36.8 49.94 41.23 8.5 3.11 11.8-5.03 11.81-4.44.67 38.61-8.96 49.76-9.95 56.24-2.7 17.65 11.81 21.69 11.81 21.69s27.96-6.77 51.37-5.05c23.41 1.72 70.4 9.36 70.4 9.36s9.67.35 10.36-12.49c.66-12.33-.47-28.31-.53-32.55 2.16 6.37 5.4 15.55 5.4 15.55l20.23-5.67-.27-17.97Z"
            style={{
              fill: '#c280b1',
            }}
          />
        </clipPath>
        <style>
          {
            '.f{fill:none}.g{fill:#006443}.h{fill:#f5aa74}.i{fill:#eb6a36}.j{fill:#f1f1f3}.k{fill:#c280b1}.l{fill:#8cb717}.m{fill:#8f9e69}.n{fill:#b39a4f}.o{fill:#e41c80}.p{fill:#d6993f}.q{fill:#394a35}.r{fill:#497125}.s{clip-path:url(#classmate2-c)}.t{clip-path:url(#classmate2-b)}.u{clip-path:url(#classmate2-e)}.v{clip-path:url(#classmate2-d)}'
          }
        </style>
      </defs>
      <path
        d="M1601.68 926.16s-4.27 19.54-.61 27.78c3.66 8.24 9.16 23.81 9.16 23.81l-31.44-4.58s-3.19-5.25-2.34-12.56c.85-7.31 6.13-23.87 6.13-23.87l2.55-14.44 16.55 3.87Z"
        style={{
          fill: '#b39a4f',
        }}
      />
      <path
        d="M1597.2 952.93c-8.32.32-17.21 10.49-18.71 10.83-4.08.92-.54-6.83-1.71-7.07-1.17-.24-3.39 8.43-4.41 16.08-1.02 7.65-1.53 11.05-.17 12.07 1.36 1.02 13.59 6.63 14.95 10.71 1.36 4.08 4.42 15.12 17.5 16.31 13.08 1.19 23.79-.51 24.47-4.59.68-4.08 1.53-11.9-1.53-15.8-3.06-3.91-9.69-7.65-13.42-14.78-3.74-7.14-7.63-15.9-8.9-18.36-1.38-2.67-3.66-5.55-8.08-5.38Z"
        style={{
          fill: '#497125',
        }}
      />
      <g
        style={{
          clipPath: 'url(#classmate2-b)',
        }}
      >
        <path
          d="M1635.93 995.54s-8.67 7.82-23.96 6.46c-15.29-1.36-20.9-5.44-23.62-10.54-2.72-5.1-6.12-9.69-9.18-12.58-3.06-2.89-9.52-9.01-9.52-9.01l-.17 26.51s34.67 33.48 35.52 33.48 42.48-16.48 42.48-16.48l-11.56-17.84Z"
          style={{
            fill: '#8f9e69',
          }}
        />
      </g>
      <path
        d="m1583.77 973.62-4.14-6.55s13-11.41 20.28-10.61c4.56.5 12.34 8.27 13.55 9.64 1.72 1.94 2.7 7.59-.8 5.09-4.12-2.95-5.78-7.93-12.41-7.08-11.21 1.44-16.48 9.52-16.48 9.52Z"
        style={{
          fill: '#8cb717',
        }}
      />
      <path
        d="M1519.94 905.09s-8.56 41.42-8.05 47.2c.51 5.78 1.85 8.57 1.85 8.57l-3.57 17.67-35.13-15.94s14.23-8.34 14.74-12.93c.51-4.59 5.58-45 5.58-45l24.58.44Z"
        style={{
          fill: '#b39a4f',
        }}
      />
      <path
        d="M1511.7 954.91c1.28-.33 3.11 11.65 4.08 15.97 1.8 8.05.34 15.46-.17 16.99-.51 1.53-18.52 2.21-28.89 7.65-10.37 5.44-20.56 7.99-32.46 7.99-11.9 0-20.39-4.59-21.24-7.14s-2.89-10.03 1.19-12.24c4.08-2.21 18.18-6.8 24.13-10.37 5.95-3.57 23.39-24.9 32.73-19.97 9.35 4.93 10.43 16.74 15.87 14.19 5.44-2.55 3.47-12.75 4.76-13.08Z"
        style={{
          fill: '#497125',
        }}
      />
      <g
        style={{
          clipPath: 'url(#classmate2-c)',
        }}
      >
        <path
          d="M1519.01 973.26s-1.02 6.29-18.35 9.69c-17.33 3.4-23.28 8.84-33.99 10.54-10.71 1.7-22.05.64-26.8-1.4-4.76-2.04-10.07-8.96-10.07-8.96l-4.42 30.93s96.18-4.59 96.52-5.1 5.95-24.47 5.44-24.64-8.33-11.05-8.33-11.05Z"
          style={{
            fill: '#8f9e69',
          }}
        />
      </g>
      <path
        d="m1498.26 971.83-7.73 3.96s-10.36-13.42-13.33-14.88c-2.8-1.37-4.15-.87-4.15-.87l7.24-5.6s5.02-.39 9.47 4.93c4.44 5.31 8.5 12.46 8.5 12.46Z"
        style={{
          fill: '#8cb717',
        }}
      />
      <path
        d="M1598.49 627.73s5.22 71.41 1.68 105c-3.41 32.39-.34 68.37.85 83.54 1.62 20.63 6.47 63.36 4.95 85.91-1.52 22.55-3.28 46.34-3.28 46.34s-4.94 2.87-14.77 2.31-15.77-3.65-15.77-3.65-2.81-24.76-5.62-53.92c-1.92-19.95-3.83-45.79-4.82-52-2.55-15.96-6.87-33.27-10.55-57.18-2.8-18.18-12.37-56.36-12.37-56.36s-6.38 57.71-8 78.54c-1.62 20.83.2 40.97-.7 65.19-1.04 28.01-14.96 76.82-14.96 76.82s-10.76 1.86-18.9.63c-8.14-1.24-12.97-4.97-12.97-4.97s5.92-49 7.08-65.15c1.29-18.13-4.2-67.37-4.71-85.84-.83-29.7-4.65-54.35-3.09-83.22 1.18-21.82-4.58-53.47-4.58-53.47s118.85-27.84 120.54-28.52Z"
        style={{
          fill: '#f1f1f3',
        }}
      />
      <path
        d="M1516.52 374.87c-29.46 6.17-31.89 28.37-30.77 46.83 1.13 18.46 10.12 28.96 14.25 41.87 4.13 12.91 3.57 46.11 3.57 46.11l9.65-.32s5.61-20.65 5.02-29.82c-.78-12.27-6.84-30.03-6.84-30.03l45.15-15.76s2.36 17.19 7.81 29.39c5.45 12.2 12.19 22.58 12.19 22.58l14.06-3.8s-.7-4.71-7.44-16.66c-5.2-9.23-10.28-20.07-14.15-36.72-1.49-6.44-3.57-29.43-12.4-41.59-7.82-10.76-21.17-16.04-40.11-12.07Z"
        style={{
          fill: '#394a35',
        }}
      />
      <g
        style={{
          clipPath: 'url(#classmate2-d)',
        }}
      >
        <path
          style={{
            fill: '#d6993f',
          }}
          d="m1519.61 396.74-6.24-25.14 1.28-.51 6.53 24.94-1.57.71z"
        />
      </g>
      <path
        d="M1519.8 395.21s-1.42 3.58-9.18 11.37c-9.5 9.54-12.71 9.62-12.36 22.66.34 12.79 2.54 15.06 2.54 15.06s-10.7-4.06-11.74 1.02c-1.04 5.08 9.52 13.91 12.16 14.09s4.74-.85 4.74-.85 2.97 9.26 10.72 12.43 14.26 8.53 20.36 6.13c6.1-2.4 19.96-12.4 21.17-16.54 1.21-4.14 2.98-14.24 2.98-14.24s4.39.84 5.92-3.35c1.53-4.19 5.92-19.67.7-19.71-5.23-.04-7.82 5.21-7.82 5.21s-2.53-4.45-8.27-15.53c-3.93-7.59-5.68-8.08-17.69-11.92-8.99-2.87-13.18-5.75-14.25-5.82Z"
        style={{
          fill: '#d6993f',
        }}
      />
      <path
        d="M1511.83 448.4s8.52 25.69 4.66 31.59c-8 12.23-26.5 18.52-26.5 18.52l35.33 32.12 28.27-.96 26.02-36.3s-19.43-5.31-21.04-13.66c-1.61-8.35.16-30.34.16-30.34l-46.9-.96Z"
        style={{
          fill: '#d6993f',
        }}
      />
      <path
        style={{
          fill: '#006443',
        }}
        d="m1505.29 433.72 5.86 1.15.19-2.9-6.24-.12.19 1.87z"
      />
      <path
        d="M1512.68 429.48c-2.5.64-3.83 2.78-3.11 5.21.72 2.43 2.58 3.02 4.86 2.58 2.7-.51 3.74-2.16 3.25-4.74-.35-1.82-2.42-3.72-4.99-3.06ZM1547.68 425.65l-4.78 3.56-1.42-2.53 5.57-2.8.63 1.77z"
        style={{
          fill: '#006443',
        }}
      />
      <path
        d="M1539.19 425.02c2.54-.5 4.66.86 5.05 3.36.39 2.5-1.02 3.83-3.27 4.43-2.65.7-4.31-.34-4.97-2.87-.47-1.79.57-4.4 3.19-4.92Z"
        style={{
          fill: '#006443',
        }}
      />
      <path
        d="M1532.36 421.87s8.93-6.32 11.3-6.53c2.37-.21 4.62 1.25 4.62 1.25l.09 1.74s-3.09-1.31-5.55.89c-2.45 2.19-8.82 6.96-8.82 6.96l-1.65-4.3ZM1517.24 425.06s-9.36-2.22-11.66-1.59c-2.3.63-4.96 2.54-4.96 2.54l.69 1.78s3.35-2.17 6.41-.97 9.48 2.86 9.48 2.86l.05-4.61Z"
        style={{
          fill: '#394a35',
        }}
      />
      <path
        d="M1406.53 531.44c5.07.15 7.79 2.54 13.01 9.11 5.22 6.56 17.57 27.11 22.03 32.95 4.46 5.84 20.19 24.32 20.57 30.69.37 6.37-3.51 21.75-12.98 20.03-9.46-1.73-21.23-23.04-25.46-34.13-4.23-11.08-13.56-37.75-15.9-36.97-2.35.78-15.69 1.97-19.84 1.55-4.15-.42-16.39-3.5-19.49-3.58-3.1-.08-17.64-6.23-17.64-6.23s.51-3.5 5.25-3.85c2.29-.17 9.2 2.58 15.79 1.95 7.08-.68 12.04-3.19 11.75-4.05-.56-1.66-9.64-2.6-13.03-4.81-5.25-3.42-1.81-7.01 2.31-6.18s12.6 2.76 15.94 3.66c5.54 1.49 9.1-.38 17.68-.13ZM1616.25 670.1s4.42 12.06 3.41 19c-.56 3.84-2.47 17.93-.8 23.13 1.66 5.2 8.09 20.38 8.09 20.38s2.57-.78 3.15-4.38c.46-2.82-3.72-11.63-2.21-11.91 1.5-.28 7.03 16.38 7.03 16.38s-4.29 1.78-4.97 4.97c-.68 3.19.61 4.02.61 4.02s10.01-5.89 11.7-6.83c1.69-.94 6.32-13.65 6.68-17.31.36-3.66-3.27-10.48-3.9-12.88-.62-2.4-5.91-13.77-6.94-19.53s-2.95-25.92-2.95-25.92l-18.9 10.88Z"
        style={{
          fill: '#d6993f',
        }}
      />
      <path
        d="M1638.59 661.01s5.4-6.2 6.7-18c1.29-11.8-6.9-35.68-15.99-65.5s-15.34-78.85-30.2-87.64c-5.94-3.51-12.19-1.5-17.37-1.6-11.4-.23-16.6-1.29-16.6-1.29s-6.85 6.19-29.93 7.13c-22.36.91-30.87-5.14-30.87-5.14s-12.86 4.95-20.42 7.3c-7.35 2.29-13.87 4.31-19.5 14.67-6.27 11.53-12.41 64.25-12.41 64.25l-14.61-16.37-10.09-12.63-16.77 13.83 5.82 11.15s-4.96 11.04 1.67 23.95c5.64 10.99 37.87 36.8 49.94 41.23 8.5 3.11 11.8-5.03 11.81-4.44.67 38.61-8.96 49.76-9.95 56.24-2.7 17.65 11.81 21.69 11.81 21.69s27.96-6.77 51.37-5.05c23.41 1.72 70.4 9.36 70.4 9.36s9.67.35 10.36-12.49c.66-12.33-.47-28.31-.53-32.55 2.16 6.37 5.4 15.55 5.4 15.55l20.23-5.67-.27-17.97Z"
        style={{
          fill: '#c280b1',
        }}
      />
      <g
        style={{
          clipPath: 'url(#classmate2-e)',
        }}
      >
        <path
          style={{
            fill: '#eb6a36',
          }}
          d="m1411.15 575.52 29-22.21-14.81-16.37-33.81 28.77 19.62 9.81zM1613.93 671.17l26.75-9.98 11.25 22.69-36.73 8.01-1.27-20.72z"
        />
        <path
          d="M1489.94 555.61s29.39-6.09 46.02-7.85c16.63-1.75 53.55-5.36 53.55-5.36l4.06 21.34s-36.57 4.06-55.88 7.11c-15.43 2.44-47.75 6.1-47.75 6.1s.88-20.9 0-21.34Z"
          style={{
            fill: 'none',
          }}
        />
        <path
          d="M1482.37 479.33s20.81 23.41 59.27 19.68c37.64-3.65 46.63-23.6 46.63-23.6s-51.82-18.87-52.94-18.49c-1.12.37-52.96 22.42-52.96 22.42Z"
          style={{
            fill: '#eb6a36',
          }}
        />
      </g>
      <path
        d="M1527.75 454.26c2.45-.69 4.9-1.19 4.9-1.19s2.52-.99 5.57-.93c3.11.07 5.34 2.76 5.54 4.26.31 2.33-.8 3.88-1.68 4.66-.88.77-1.81 2.29-6.57 3.15-4.22.76-6.85.28-8.47-.1-2.08-.5-2.75-1.72-2.95-3.47-.19-1.6 1.33-5.72 3.66-6.38Zm1.84 5.48c.27.65 2.46-.02 4.47-.48 2-.46 3.94-.69 3.85-1.99-.05-.69-3.08-.66-4.88-.26-1.48.33-3.76 1.96-3.43 2.73Z"
        style={{
          fill: '#f5aa74',
        }}
      />
      <path
        d="M1568.46 471.57s5.97 11 9.42 17.45c2.47 4.61 7.74 7.83 7.74 7.83l.65 4.55s-3.12 4.99-1.59 14.05c1.04 6.1 7.09 23.19 7.09 23.19s13.06-12.05 9.6-24.3c-1.97-6.97-6.77-15.02-6.77-15.02l-1.17-4.94s1.98-2.01-.3-7.88c-4.23-10.92-9.11-19.32-9.11-19.32l-15.55 4.4Z"
        style={{
          fill: '#394a35',
        }}
      />
      <path
        style={{
          fill: '#e41c80',
        }}
        d="m1585.43 496.63 1.05 4.31 7.98-1.96-.94-4.71-8.09 2.36z"
      />
    </svg>
  )
}

export default Classmate2Start
